








import { Component, Vue } from "vue-property-decorator";
import router from "@/router";
import { ChampionOrigin, costColor } from "@/models/champion";
import { championDeck } from "@/store/index";

@Component({
  name: "deck-origin",
  components: {
    "champion-deck-group": () =>
      import("@/components/Molecules/ChampionDeckGroup.vue")
  }
})
export default class DeckOrigin extends Vue {
  costColor: Map<number, string> = costColor;

  mounted() {
    championDeck.separateChampionDeckOrigin();
  }

  get championListEachOrigin(): ChampionOrigin[] {
    return championDeck.deckOrigin;
  }
}
